import { InjectionToken } from '@angular/core';

export const TREO_MOCK_API_DEFAULT_DELAY = new InjectionToken<number>('TREO_MOCK_API_DEFAULT_DELAY');
